// LF360-2011 — a task's LifePoints come from its category, so the server
// publishes no task without one. These are the words for its refusals, used by
// the card while it is being edited and by the publish action, so an admin
// learns why before pressing Publish and is told why if they press it anyway.
export const CATEGORY_ERROR_MESSAGES = {
  CATEGORY_REQUIRED:
    'Choose a category. A task without one awards no LifePoints and cannot be published.',
  CATEGORY_NOT_FOUND:
    'This category is not in the project any more. Choose another one.',
};

/** The words for a refusal over the category, or null when it was not one. */
export const categoryRefusal = (error) =>
  CATEGORY_ERROR_MESSAGES[error?.response?.data?.error] || null;

/** What to tell an admin whose publish was refused. */
export const publishErrorMessage = (error) =>
  categoryRefusal(error) || 'Failed to publish task';
